import { jsx as _jsx } from "react/jsx-runtime";
import SVGIcon from 'react-svg';
import { fontSizeMapper } from '@appspotr/app';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/pro-regular-svg-icons/faQuestion';
var FontIconSingle = function (_a) {
    var icon = _a.icon, size = _a.size, _b = _a.color, color = _b === void 0 ? '' : _b;
    var selectedSize = size || '2x';
    if (icon && icon.extId) {
        var fontSize_1 = fontSizeMapper[size] ? "".concat(fontSizeMapper[size], "px") : size;
        return (_jsx(SVGIcon, { afterInjection: function (error) {
                if (error) {
                    console.error(error);
                }
            }, beforeInjection: function (svg) {
                svg.classList.add('svg-class-name');
                svg.setAttribute('style', "height: ".concat(fontSize_1, ";\n             width: ").concat(fontSize_1, ";\n             color: ").concat(color, "; margin-top:-3px"));
            }, src: "".concat(process.env.ICON_BUCKET_URL, "/").concat(icon.extId) }));
    }
    return icon ? (_jsx(FontAwesomeIcon, { color: color || 'unset', size: selectedSize, icon: icon || faQuestion })) : null;
};
export default FontIconSingle;
